import { IChatHintSchema } from 'shared/repositories/chats/entities/chat_hint/ChatHintSchema';

export enum EChatsActionTypes {
  StateReceived = 'IChatsStateReceived',
  OfferChatReceived = 'IOfferChatReceived',
  OnlineStatusReceived = 'IOnlineStatusReceived',
  HintQuestionsReceived = 'IHintQuestionsReceived',
  OpenChat = 'IOpenChat',
  CloseChat = 'ICloseChat',
}

export type TChatAction =
  | IChatsStateReceived
  | IOfferChatReceived
  | IOnlineStatusReceived
  | IHintQuestionsReceived
  | IOpenChat
  | ICloseChat;

export interface IChatsStateReceived {
  type: EChatsActionTypes.StateReceived;
  payload: {
    enabled: boolean;
  };
}

export const chatsStateReceived = (enabled: boolean): IChatsStateReceived => ({
  payload: { enabled },
  type: EChatsActionTypes.StateReceived,
});

export interface IOfferChatReceived {
  type: EChatsActionTypes.OfferChatReceived;
  payload: {
    chatId: string;
  };
}

export const offerChatReceived = (chatId: string): IOfferChatReceived => ({
  payload: { chatId },
  type: EChatsActionTypes.OfferChatReceived,
});

export interface IOnlineStatusReceived {
  type: EChatsActionTypes.OnlineStatusReceived;
  payload: {
    isOnline: boolean;
  };
}

export const onlineStatusReceived = (isOnline: boolean): IOnlineStatusReceived => ({
  payload: { isOnline },
  type: EChatsActionTypes.OnlineStatusReceived,
});

export interface IHintQuestionsReceived {
  type: EChatsActionTypes.HintQuestionsReceived;
  payload: {
    hintQuestions: IChatHintSchema[];
  };
}

export const hintQuestionsReceived = (hintQuestions: IChatHintSchema[]): IHintQuestionsReceived => ({
  payload: { hintQuestions },
  type: EChatsActionTypes.HintQuestionsReceived,
});

export interface IOpenChat {
  type: EChatsActionTypes.OpenChat;
  payload: {
    type?: 'open_phone' | 'open_message';
    defaultMessage?: string;
  };
}

type TOpenChatParameters = {
  type?: 'open_phone' | 'open_message';
  defaultMessage?: string;
};

export const openChat = ({ type, defaultMessage }: TOpenChatParameters | void = {}): IOpenChat => ({
  type: EChatsActionTypes.OpenChat,
  payload: {
    type,
    defaultMessage,
  },
});

export interface ICloseChat {
  type: EChatsActionTypes.CloseChat;
}

export const closeChat = (): ICloseChat => ({
  type: EChatsActionTypes.CloseChat,
});
